// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","cityCardButtons":"city-card-buttons_cityCardButtons__pn8bl","investmentOpportunities":"city-card-buttons_investmentOpportunities__S2w9k"};